// extracted by mini-css-extract-plugin
export var toTop = "ToTop-module--to-top--1aM8H";
export var visible = "ToTop-module--visible--3iSSy";
export var spinAround = "ToTop-module--spinAround--2JZv9";